import { render } from "./Amplification.vue?vue&type=template&id=6a83fa15&scoped=true"
import script from "./Amplification.vue?vue&type=script&lang=js"
export * from "./Amplification.vue?vue&type=script&lang=js"

import "./Amplification.vue?vue&type=style&index=0&id=6a83fa15&scoped=true&lang=less"

import exportComponent from "/Users/longliu/Desktop/projects/povertyalleviation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a83fa15"]])

export default __exports__